<template>
  <div :class="divWidthChange" class="conteudoWidth fccEmulados">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsEmulados"
          responsive
          :porPage="itemPorPage"
          search
          :optionsButton="optionsButton"
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsEmulados"
          :items="emulados"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editEmulador"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      v-if="Object.keys(emulador).length"
    >
      <form @submit.prevent="adicionaEmulado()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione"
              labelField="usunome"
              v-model="emuladoEscolhido"
              :options="todosEmular"
              required
            >
              Usuário
            </fcc-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './../assets/fccUsuarios.scss'

export default {
  data() {
    return {
      statusGrupo: [
        {
          funcaoButton: 'changeGrupo',
          tooltip: 'Alterar Status',
          campoStatus: 'perativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsEmulados: [
        { key: 'usuid', label: 'ID', sortable: true, active: true },
        {
          key: 'usucompnome',
          label: 'Nome',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompnome' }
        },
        {
          key: 'usucompsgsetor',
          label: 'Setor',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompsgsetor' }
        },
        { key: 'actions', label: '', active: true }
      ],
      optionsButton: [
        { funcaoButton: 'voltarField', tooltip: 'Voltar', text: 'Voltar', icon: 'chevron-left' },
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          text: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      actionsEmulados: [
        {
          button: true,
          funcaoButton: 'deletandoEmulado',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      voltar: '',
      baseUrlSeguranca: '',
      sortBy: 'ordem',
      titlePage: 'Emuladores',
      titleModal: '',
      emulador: {},
      emulados: [],
      todosEmular: [],
      emuladoEscolhido: '',
      titlePDF: 'Emuladores',
      itemPorPage: '100'
    }
  },
  methods: {
    voltarField: function () {
      if (this.voltar === 'false') {
        this.$router.push({ path: '/seguranca/emuladores' })
      } else {
        this.$router.push({ path: '/seguranca/emulador' })
      }
    },
    adicionaEmulado: function () {
      const emula = {
        usuEmuladoID: 0,
        usuEmuID: this.emulador.usuemuid,
        usuID: this.emuladoEscolhido.usuid
      }
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlSeguranca + 'Emulados/incluiremulado',
          emula,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.emuladoEscolhido = ''
          this.listaLoginPorUsuId(this.usuid)
          this.$root.$emit('bv::hide::modal', 'editEmulador')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deletandoEmulado: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.usuid).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Emulados/excluiremulado?usuEmuladoID=' + item.usuemuladoid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listaLoginPorUsuId(this.usuid)
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    listaLoginPorUsuId(usuId) {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          this.baseUrlSeguranca + 'Cadastro/listarlogin/' + usuId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.emulador = response.data
          this.listarTodosPodeEmular()
          this.titlePage = 'Emulados de ' + this.emulador.usuariocomplemento.usucompnome
          this.listarEmuladosPorId(usuId)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarEmuladosPorId(usuId) {
      this.listEmuladosPorId(usuId).then((response) => {
        this.emulados = response
        this.carregaTexto()
      })
    },
    filtraArray(array, array2) {
      return array.filter((item) => !array2.some((elem) => item.usuid === elem.usuid))
    },
    listarTodosPodeEmular() {
      axios
        .get(
          this.baseUrlSeguranca + 'Emulados/listartodosemulado',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.todosEmular = []
          if (response.data.length > 0) {
            const removeArray = this.filtraArray(response.data, [this.emulador])
            const emuladosFinal = this.filtraArray(removeArray, this.emulados)
            emuladosFinal.forEach((element) => {
              const ajustes = {
                usuid: element.usuid,
                usunome: element.usuariocomplemento.usucompnome + ' (' + element.usuid + ')'
              }
              this.todosEmular.push(ajustes)
            })
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar Emulado para ' + this.emulador.usuariocomplemento.usucompnome
      this.$root.$emit('bv::show::modal', 'editEmulador')
    }
  },
  mounted: function () {
    this.usuid = this.$route.params.id
    this.voltar = this.$route.params.voltar
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.listaLoginPorUsuId(this.usuid)
  }
}
</script>
